export const storageKeys = {
  ACCOUNT: 'ACCOUNT',
  RAMP_SETTINGS: 'RAMP_SETTINGS',
  POOL_SETTINGS: 'POOL_SETTINGS',
  OFFRAMP_STATUS: 'OFFRAMP_STATUS',
  OFFRAMP_EXECUTION_INPUTS: 'OFFRAMP_EXECUTION_INPUTS',
  PENDULUM_SEED: 'PENDULUM_SEED',
  STELLAR_SEED: 'STELLAR_SEED',
  SEP_RESULT: 'SEP24_RESULT',
  ANCHOR_SESSION_PARAMS: 'ANCHOR_SESSION_PARAMS',
  STELLAR_OPERATIONS: 'STELLAR_OPERATIONS',
  TOKEN_BRIDGED_AMOUNT: 'TOKEN_BRIDGED_AMOUNT',
  SIWE_SIGNATURE_KEY_PREFIX: 'SIWE_SIGNATURE_',

  // Internal squidrouter recovery states
  SQUIDROUTER_RECOVERY_STATE_APPROVAL: 'SQUIDROUTER_TRANSACTION_STATE_APPROVAL',
  SQUIDROUTER_RECOVERY_STATE_SWAP: 'SQUIDROUTER_TRANSACTION_STATE_SWAP',

  LAST_TRANSACTION_SUBMISSION_INDEX: 'LAST_TRANSACTION_SUBMISSION_INDEX',
};

/// This enum is used to keep track of the last transaction submission index. This is used to determine if a transaction has been submitted before.
/// The indices are used to determine which transaction was last submitted.
export enum TransactionSubmissionIndices {
  SQUIDROUTER_APPROVE = 0,
  SQUIDROUTER_SWAP = 1,

  ASSETHUB_XCM = 0,
  MOONBEAM_XCM = 1,
}
